import VisuraButtonsRendering from "./visura-buttons";
import { toast } from "react-toastify";
import * as visuraSlice from "../visura.slice";
import { useDispatch, useSelector } from "react-redux";
import { TIMER } from "..";

function VisuraButtons() {
  const dispatch = useDispatch();
  const apiResponse = useSelector(visuraSlice.selectApiResponse);
  const lastFileName = useSelector(visuraSlice.selectLastFileName);
  const handleCopyToClipboardClick = () => {
    navigator.clipboard.writeText(apiResponse);
    toast.success("visura copiata negli appunti!", {
      position: "top-right",
      autoClose: TIMER,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const handleResetButtonClick = () => {
    dispatch(visuraSlice.clearStatus({ status: visuraSlice.Status.IDLE }));
    navigator.clipboard.writeText("");
    toast.success("Appunti svuotati con successo!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };
  return (
    <VisuraButtonsRendering
      onCopyToClipboardButtonCLick={handleCopyToClipboardClick}
      onResetButtonClick={handleResetButtonClick}
      apiResponse={apiResponse}
      lastFileName={lastFileName}
    />
  );
}

export default VisuraButtons;
